<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="title-big">
            <h1>Hello</h1>
        </div>
        <div class="title-text">
            欢迎来到爱驿站 {{ stationName }}
        </div>
        <div class="title-text">
            您前面还有 <span style="color: #FE405F"> {{waiting}} </span> 位顾客在等待
        </div>


        <div class="title-num">
            {{callCount}}
        </div>
        <div class="title-tips">
            您的号码已叫过, 如错过, 请重新叫号
        </div>

        <div class="reload-btn" @click="onReload">
            重新叫号
        </div>

        <div class="footer">
            <p>江苏爱驿站信息科技有限公司</p>
            <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
        </div>


    </div>
</template>

<script>

import ayzAjax from "@/plugins/axios";
import {showFailToast} from "vant";

export default {
    name: "ReloadView",
    data: function () {
        return {
            stationName:'',
            waiting:0,
            callCount:0,
        }
    },
    created() {
        this.onTicket();
    },
    methods: {
        onReload(){


            // token
            let fromData = {};
            fromData.mobile = this.ticket.mobile;
            fromData.token = this.ticket.token;
            fromData.station_id = this.station.id;

            ayzAjax.post('/call/enqueue',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                localStorage.setItem('callTicket', JSON.stringify(response.data.data));
                this.$router.push({ path: '/call/cancel'});
            })

        },
        onTicket(){
            this.station = JSON.parse(localStorage.getItem('station'));
            this.stationName = this.station.title;
            this.ticket = JSON.parse(localStorage.getItem('callTicket'));
            let fromData = {}
            fromData.ticket_id = this.ticket.ticket_id;
            fromData.token = this.ticket.token;
            ayzAjax.post('/call/my_queueing_info',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                localStorage.setItem('callTicket', JSON.stringify(response.data.data));
                this.$router.push({ path: '/call/reload'});
                this.ticket = JSON.parse(localStorage.getItem('callTicket'));
                this.waiting = this.ticket.wait_count;
                this.callCount = this.ticket.ticket_number;
                if(this.ticket.status === 1){
                    this.$router.push({ path: '/call/cancel'});
                }
            })
        }

    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    //width: 100%;
    background-color: #FFFFFF;
    text-align: left;
    padding: 40px 30px 0 30px;
    .title-big{
        margin: 10px 10px 40px 10px;
    }
    .title-text{
        margin: 20px 10px 0 10px;
        font-weight: 550;
        font-size: 15px;
    }
    .title-num{
        margin-top: 100px;
        color: #222222;
        //margin-bottom: 100px;
        text-align: center;
        font-weight: bold;
        font-size: 150px;
    }
    .title-tips{
        text-align: center;
        color: #FE405F;
    }
    .reload-btn{
        margin-top: 80px;
        height: 60px;
        line-height: 60px;
        background-color: #FE405F;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
    .footer{
        margin-top: 80px;
        padding-bottom: 20px;
        text-align: center;
        color: #A5A5A5;
        font-weight: 300;
        font-size: 13px;
    }
}
</style>
